'use strict';
import React, { Component, Fragment, useState } from 'react';
import { connect, dispatch } from 'react-redux';
import axios from 'axios';

import { Global_ISDA_Functions } from 'Root/global/global';
import Papa from 'papaparse';
import * as XLSX from "xlsx";
import { checkExistingUpload, bulkAdherencesContact, verificationAndFinalMessage } from '../actions';

global.isdaFunctions = new Global_ISDA_Functions();
global.fundSetCount = 1;
global.editModeWiped = false;

class BulkUploadLetters extends Component {
	constructor() {
		super();
		this.state = {
			setFile: null,
			CSVData: '',
			validationErr: '',
			userID: '',
			pendingUpload: false,
			checked: false,
			message: ''
		};
	}

	componentDidMount() {
		let csv_div   = document.getElementById("btn-upload-letters-csv"),
			user_id   = csv_div.getAttribute('data-user');

		this.props.checkExistingUpload( user_id );
		this.displayProgressBar();
		setTimeout( () => {
			if ( (this.props.pending).length > 1 ) {
				this.setState( { pendingUpload: true } );
				this.hideUploadSuccess();
			} else {
				this.setState( { pendingUpload: false } );
				this.hideUploadSuccess();

				this.setState( { message: <h4 className='form-step'>No pending uploads found. Please upload your CSV/Excel.</h4> } );
			}
		}, 9000 );
	}

	componentDidUpdate() {
	}

	convertToJson( string ) {
		const results = Papa.parse( string, {
			header        : true,  // Treat the first row as headers
			skipEmptyLines: true
		} );

		return results.data;
	}

	handleUpload( e ) {
		let thisScope = this,
		    csv_div   = document.getElementById("btn-upload-letters-csv"),
		    user_id   = csv_div.getAttribute('data-user');

		this.setState( { message: '' } );
		if ( csv_div.files.length === 0 ) {
			thisScope.displayCsvError();
			return false;
		} else {
			thisScope.removeCsvError();
		}

		let file        = document.getElementById( 'btn-upload-letters-csv' ).files[ 0 ],
		    extension   = file.name.split( '.' ).pop(),
		    loadingIcon = document.getElementById( 'csv-loading-progress' ),
		    url         = '/wp-content/themes/isda-theme-underscores/src/js/protocols/protocol-adherence/bulk-upload-letters/temp/';

		this.state.setFile = file; // Store the file temporarily
		this.setState( { checked: false  } );

		if ( extension !== 'csv' && extension !== 'xlsx' ) {
			thisScope.displayCsvError();
			return false;
		} else {
			thisScope.removeCsvError();
		}

		thisScope.displayUploadSuccess( loadingIcon );

		if ( ! file ) {
			alert( 'Please select a file first!' );
			return;
		}

		const formData = new FormData();
		formData.append("file", file);

		const reader = new FileReader();

		if ( extension === 'csv' ) {
			reader.onload = ( e ) => {
				const text = e.target.result;
				const json = this.convertToJson( text );//array objects.

				this.setState({ CSVData: json }, () => {
					const setJsonOutput = JSON.stringify( this.state.CSVData, null, 2 );
					sessionStorage.setItem("tempFile", setJsonOutput);
					thisScope.handleValidation( this.state.CSVData, user_id );
				});
			};

			reader.readAsText( file );

		} else if ( extension === 'xlsx' ) {
			reader.onload = ( e ) => {
				const data      = new Uint8Array( e.target.result );
				const workbook  = XLSX.read( data, { type: 'array' } );
				const sheetName = workbook.SheetNames[ 0 ];
				const json = XLSX.utils.sheet_to_json( workbook.Sheets[ sheetName ], {
					raw   : true,
					defval: ''
				} );//Convert sheet to JSON.

				this.setState({ CSVData: json }, () => {
					const setJsonOutput = JSON.stringify( this.state.CSVData, null, 2 );
					sessionStorage.setItem("tempFile", setJsonOutput);
					thisScope.handleValidation( this.state.CSVData, user_id );
				});
			};

			reader.readAsArrayBuffer(file);
		}

	}

	firstAWSresponse( setTime ) {
		const wrapper     = document.getElementById( 'csv-upload-error' ),
		      h4          = document.createElement( 'h4' ),
		      csv_div     = document.getElementById("btn-upload-letters-csv"),
		      user_id     = csv_div.getAttribute('data-user');

		let time = parseInt( setTime - 4000 );

		if ( this.props.contact !== '' ) {
			this.props.checkExistingUpload( user_id, time );
			setTimeout( () => {
				if ( this.props.pending ) {
					this.setState( { pendingUpload: true } );
				} else {
					this.hideUploadSuccess();
					wrapper.innerHTML = '<h4 class="padding-top-xl site-content">Something went wrong. Please refresh the page and(or) re-upload the files. </h4>';
				}
			}, ( setTime - 2000 ) );
		} else {
			wrapper.innerHTML = '<h4 class="padding-top-xl site-content">We are having connection issues. Please try again after sometime. </h4>';
		}
	}

	handleValidation( data, user_id ) {
		let wrapper   = document.getElementById( 'csv-upload-error' ),
		    allErrors = '',
			row = 1,col = 0;

		const urlParams   = new URLSearchParams( window.location.search ),
		      prot_id     = urlParams.get( 'protocol-id' ),
		      loadingIcon = document.getElementById( 'csv-loading-progress' );

		data.forEach( ( elem ) => {
			row = row + 1;
			let option_msg = '', up_check = '', up_needs_validation = true;

			elem.row_num_original = row;

			if ( elem['Adherence Type'] !== 'Single Entity Adherence' ) {
				if ( elem['Option 1'] === 'yes' && elem['Option 2'] === 'yes' ) {
					option_msg = '<h4> IM Adherences must select one and only one Option.</h4>';
				} else if ( elem['Option 1'] !== 'yes' && elem['Option 2'] !== 'yes' ) {
					option_msg = '<h4> at least one Option should be selected for IM Adherences.</h4>';
				} else {
					option_msg = '';
				}
			} else {
				if ( elem['Option 1'] === 'yes' || elem['Option 2'] === 'yes' ) {
					option_msg = '<h4> Options cannot be selected for Single Entity Adherence.</h4>'
				}
			}

			if ( elem['Ultimate Parent LEI'] === '' && elem['Ultimate Parent Name'] === '' ) {
				up_needs_validation = false;
			} else if ( ( elem['Ultimate Parent LEI'] !== '' && elem['Ultimate Parent Name'] === '' ) || ( elem['Ultimate Parent LEI'] === '' && elem['Ultimate Parent Name'] !== '' ) ) {
				up_check = '<h4> Ultimate Parent Name and Ultimate Parent LEI must appear together.</h4>';
			}

			Object.entries( elem ).forEach( ( [key, value], index ) => {
				col = index +1;
				let field_valid = this.ifFieldHasIssue( key, value, up_needs_validation );

				if ( key === 'Adherence Type' && value === '' ) {
					allErrors += `<div class="latest alert alert-danger">On Row ${ row }  Col ${ col } Adherence Type should not be empty.</div>`;
				}

				if ( key === 'Adherence Type' && option_msg !== '' ) {
					allErrors += `<div class="latest alert alert-danger">On Row ${ row } Col 4-5 ${ option_msg }</div>`;
				} else if ( key === 'Ultimate Parent LEI' && up_check !== '' ) {
					allErrors += `<div class="latest alert alert-danger">On Row ${ row } Col ${ col } ${ key }: ${ value } ${ up_check }</div>`;
				}

				if ( field_valid ) {
					allErrors += `<div class="latest alert alert-danger">On Row ${ row } Col ${ col } ${ key }: ${ value } ${ field_valid }</div>`;
				}
			} );
		} );

		if ( allErrors ) {
			this.hideUploadSuccess();
			this.setState( { pendingUpload: false } );
			wrapper.innerHTML = '<h4 class="padding-top-xl site-content"> Please fix the below errors in your file and try uploading again. </h4>' + allErrors;
			global.isdaFunctions.vanillaAddClass( wrapper );
		} else {
			this.setState( { pendingUpload: false } );
			this.displayUploadSuccess( loadingIcon );
			this.props.bulkAdherencesContact( user_id, data, prot_id );

			let setTime;
			if ( data.length < 20 ) {
				setTime = 12000;
			} else if ( data.length < 50 ) {
				setTime = 18000;
			} else if ( data.length < 100 ) {
				setTime = 22000;
			} else {
				setTime = 25000;
			}

			setTimeout( () => {
				this.firstAWSresponse( setTime );
			}, setTime );
		}
	}

	ifFieldHasIssue( key, value, up_needs_validation ) {
		switch ( key ) {
			case 'Organization Name':
			case 'Super-User Name':
			case 'Authorized Signatory Name':
			case 'Authorized Signatory Title':
				return ( value.length < 3 ) ? '<h4> is not valid. Should be greater than 2 characters.</h4>' : false;
			case 'Organization LEI':
				return ( value.length !== 20 ) ? '<h4> Required (20 characters).</h4>' : false;
			case 'Ultimate Parent LEI':
				if ( up_needs_validation )
				return ( value.length !== 20 ) ? '<h4> Required (20 characters).</h4>' : false;
				break;
			case 'Ultimate Parent Name':
				if ( up_needs_validation )
					return ( value.length < 3 ) ? '<h4> is not valid. Should be greater than 2 characters.</h4>' : false;
				break;
			case 'Super-User Email':
				return ( value.length < 3  ||  ! value.match( /.+@.+\..+/i ) ) ? '<h4> is not valid E-mail.</h4>' : false;
			case 'Authorized Signatory Email':
				return ( value.length < 3  ||  !value.match( /.+@.+\..+/i ) ) ? '<h4> is not valid E-mail.</h4>' : false;
		}
	}

	displayCsvError() {
		let wrapper = document.getElementById( 'csv-upload-error' );

		global.isdaFunctions.vanillaAddClass( wrapper, 'alert' );
		global.isdaFunctions.vanillaAddClass( wrapper, 'alert-danger' );
		wrapper.innerHTML = 'Please upload a valid CSV file.';
	}

	removeCsvError() {
		let wrapper = document.getElementById( 'csv-upload-error' );

		global.isdaFunctions.vanillaRemoveClass( wrapper, 'alert' );
		global.isdaFunctions.vanillaRemoveClass( wrapper, 'alert-danger' );
		wrapper.innerHTML = '';
	}

	displayUploadSuccess( wrapper ) {
		global.isdaFunctions.vanillaRemoveClass( wrapper, 'hidden' );
		wrapper.innerHTML = 'Upload in progress. Please give large files up to a minute to upload. Do not refresh your browser. <img src="' + ISDA_Main.ajaxLoader + '"/>';
	}

	displayProgressBar() {
		let wrapper = document.getElementById( 'csv-loading-progress' );

		global.isdaFunctions.vanillaRemoveClass( wrapper, 'hidden' );
		wrapper.innerHTML = 'Checking for pending upload. Please wait <img src="' + ISDA_Main.ajaxLoader + '"/>';
	}

	hideUploadSuccess() {
		let wrapper = document.getElementById( 'csv-loading-progress' );

		global.isdaFunctions.vanillaAddClass( wrapper, 'hidden' );
	}

	handleChange( event ) {
		const wrapper     = document.getElementById( 'csv-upload-error' ),
		      content_sec = document.getElementById( 'content-area' ),
		      urlParams   = new URLSearchParams( window.location.search ),
		      prot_id     = urlParams.get( 'protocol-id' ),
		      csv_div     = document.getElementById("btn-upload-letters-csv"),
		      user_id     = csv_div.getAttribute('data-user');

		this.setState( { checked: event.target.checked  } );
		wrapper.innerHTML = 'Please wait <img src="' + ISDA_Main.ajaxLoader + '"/>';
		if ( event.target.checked ) {
			this.props.verificationAndFinalMessage( user_id, prot_id );
		}

		setTimeout( () => {
			this.setState( { pendingUpload: false  } );
			wrapper.innerHTML = '<h4 class="padding-top-xl site-content">' + this.props.iverify + '</h4>';
			global.isdaFunctions.vanillaAddClass( wrapper );
		}, 5000 );
	}

	showPending() {
		this.hideUploadSuccess();
		if ( this.props.pending.includes("Thank you") ) {
			return (<h4 className="padding-top-xl site-content"
			            dangerouslySetInnerHTML={ { __html: this.props.pending } }/>
			);
		} else {
			return (<Fragment>
					<h4 className="padding-top-xl site-content"> Please fix the
						below errors in your file and try uploading again. You can check the <a href="https://search.gleif.org" target="_blank">GLEIF Database</a> to confirm that your LEIs are valid and active and that your Org Name matches.</h4>
					<div className="latest alert alert-warning"
					     dangerouslySetInnerHTML={ { __html: this.props.pending } }/>
				</Fragment>
			);
		}
	}

	render( contact ) {
		return (
			<Fragment>
				<button type="button" id="btn-prefill-funds" aria-label="Pre-fill fund fields from csv" className="btn btn-default col-sm-3 conditional-form-group" onClick={ this.handleUpload.bind( this ) }>Upload</button>
				<div className="col-xs-12 padding-top-xl site-content" id="content-area">{ this.state.pendingUpload
				                             ? this.showPending()
				                             : this.state.message }</div>
				<div className="col-sm-12">
					<div id="csv-loading-progress" className="alert alert-info hidden"></div>
					<div id="csv-upload-error"></div>
				</div>
				<div id="csv-upload-content" className="col-sm-12"></div>
			</Fragment>
		);
	}
}

function mapStateToProps( { contact, pending, iverify } ) {
	return { contact, pending, iverify };
}

export default connect( mapStateToProps, {
	bulkAdherencesContact, checkExistingUpload, verificationAndFinalMessage
} )( BulkUploadLetters );